module.exports = __webpack_public_path__ + "static/Diagram-4-ab4f5fc4d12c8e70d107f8e9530529c6.png";